import React from "react";
var __jsx = React.createElement;
import { Conditional } from "@componentsShared/Conditional/Conditional";
import { Then } from "@componentsShared/Conditional/Then";
import { Else } from "@componentsShared/Conditional/Else";
import { PURCHASE_METHOD_ARIB, PURCHASE_METHOD_NORMAL_FINANCE, useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import RadioCardNew from "@/pages/checkout/pre-checkout/RadioCard/RadioCardNew";
import { useTranslation } from "@i18n";
import { SHOW_DEBUG_INFO } from "@globalConfig";
var FinanceOptionTwo = function FinanceOptionTwo(_ref) {
  var _checkoutOrder$story_, _checkoutOrder$story_2, _checkoutOrder$story_4, _checkoutOrder$story_5;
  var disabled = _ref.disabled;
  var _useCheckoutOrder$sta = useCheckoutOrder().state,
    checkoutOrder = _useCheckoutOrder$sta.checkoutOrder,
    purchaseMethod = _useCheckoutOrder$sta.purchaseMethod,
    financeModal = _useCheckoutOrder$sta.financeModal;
  var action__setPurchaseMethod = useCheckoutOrder().actions.action__setPurchaseMethod;
  var _useTranslation = useTranslation(),
    tShort = _useTranslation.tShort;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Conditional, {
    condition: !!(checkoutOrder !== null && checkoutOrder !== void 0 && checkoutOrder.is_eligible_for_arib)
  }, /*#__PURE__*/React.createElement(Then, null, /*#__PURE__*/React.createElement(RadioCardNew, {
    id: "precheckout-arib-option",
    name: "arib",
    value: PURCHASE_METHOD_ARIB,
    checked: purchaseMethod === PURCHASE_METHOD_ARIB,
    onChange: function onChange(e) {
      action__setPurchaseMethod(e.target.value);
    },
    disabledNote: /*#__PURE__*/React.createElement(React.Fragment, null, tShort("pre-checkout/finance_not_enabled", {
      ns: "web_pre_checkout"
    })),
    title: (SHOW_DEBUG_INFO ? "ARIB-> " : "") + tShort("pre-checkout/finance_title", {
      ns: "web_pre_checkout"
    }),
    description: tShort("pre-checkout/finance_description", {
      ns: "web_pre_checkout"
    }),
    ctaText: tShort("pre-checkout/how_to_finance_sub", {
      ns: "web_pre_checkout"
    }),
    story: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$story_ = checkoutOrder.story_section) === null || _checkoutOrder$story_ === void 0 ? void 0 : (_checkoutOrder$story_2 = _checkoutOrder$story_.finance_story) === null || _checkoutOrder$story_2 === void 0 ? void 0 : _checkoutOrder$story_2.data.map(function (story, idx) {
      var _checkoutOrder$story_3;
      return /*#__PURE__*/React.createElement("div", {
        key: "stry" + idx,
        className: "singleStry"
      }, /*#__PURE__*/React.createElement("strong", {
        style: {
          textAlign: "center"
        }
      }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$story_3 = checkoutOrder.story_section) === null || _checkoutOrder$story_3 === void 0 ? void 0 : _checkoutOrder$story_3.finance_story.title), /*#__PURE__*/React.createElement("img", {
        src: story.image,
        alt: "story"
      }));
    }),
    disabled: disabled,
    onClickCta: function onClickCta(e) {
      e.preventDefault();
      e.stopPropagation();
      financeModal.setTrue();
    },
    showStoryModal: false
  })), /*#__PURE__*/React.createElement(Else, null, /*#__PURE__*/React.createElement(RadioCardNew, {
    id: "precheckout-installment-option",
    name: "normal-finance",
    value: PURCHASE_METHOD_NORMAL_FINANCE,
    checked: purchaseMethod === PURCHASE_METHOD_NORMAL_FINANCE,
    onChange: function onChange(e) {
      action__setPurchaseMethod(e.target.value);
    },
    disabledNote: /*#__PURE__*/React.createElement(React.Fragment, null, tShort("pre-checkout/normal_not_enabled", {
      ns: "web_pre_checkout"
    })),
    storyText: t("how_finance_car_syarah", {
      ns: "web_pre_checkout"
    }),
    title: (SHOW_DEBUG_INFO ? "Normal finance-> " : "") + tShort("pre-checkout/finance_title", {
      ns: "web_pre_checkout"
    }),
    description: tShort("pre-checkout/finance_description", {
      ns: "web_pre_checkout"
    }),
    ctaText: tShort("pre-checkout/how_to_finance_sub", {
      ns: "web_pre_checkout"
    }),
    story: checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$story_4 = checkoutOrder.story_section) === null || _checkoutOrder$story_4 === void 0 ? void 0 : (_checkoutOrder$story_5 = _checkoutOrder$story_4.finance_story) === null || _checkoutOrder$story_5 === void 0 ? void 0 : _checkoutOrder$story_5.data.map(function (story, idx) {
      var _checkoutOrder$story_6;
      return /*#__PURE__*/React.createElement("div", {
        key: "stry" + idx,
        className: "singleStry"
      }, /*#__PURE__*/React.createElement("strong", {
        style: {
          textAlign: "center"
        }
      }, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$story_6 = checkoutOrder.story_section) === null || _checkoutOrder$story_6 === void 0 ? void 0 : _checkoutOrder$story_6.finance_story.title), /*#__PURE__*/React.createElement("img", {
        src: story.image,
        alt: "story"
      }));
    }),
    disabled: disabled,
    showStoryModal: false,
    onClickCta: function onClickCta(e) {
      e.preventDefault();
      e.stopPropagation();
      financeModal.setTrue();
    }
  }))));
};
export default FinanceOptionTwo;